// extracted by mini-css-extract-plugin
module.exports = {"actions":"Industries_actions__3oVlC"};